<template>
  <div>
    <b-modal id="modalTariffPlans" ref="modalTariffPlans" :title="$t('Tariff plans detail')" hide-footer>
      <div v-if="currentRowTariffPlans">
          <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
            <b-form-input type="text" v-model="currentRowTariffPlans.id" disabled/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Tariff name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="currentRowTariffPlans.name" aria-describedby="inputFeedbackName" :state="currentRowTariffPlans.name.length > 0"/>
            <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="currentRowTariffPlans.comments"/>
          </b-form-group>
          <div v-if="isEdit">
            <b-form-group label-align="right" :label="$t('Created on')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="currentRowTariffPlans.create_date" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Created by')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="currentRowTariffPlans.whoCreate" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Created by')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="currentRowTariffPlans.change_date" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Modified by')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="currentRowTariffPlans.whoChange" disabled/>
            </b-form-group>
          </div>
          <b-form-group :label="$t('Zero balance at the accounting period end')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-checkbox switch size="lg" v-model="currentRowTariffPlans.balance_rollover" value="1" unchecked-value="0"/>
          </b-form-group>
          <b-row v-if="isEdit && currentRowTariffPlans.id != 0" align-h="center">
            <md-button class="md-raised" @click="showParentService">{{ $t('Add service') }}</md-button>
          </b-row>
          <b-table striped hover small v-if="isEdit && currentRowTariffPlans.id != 0"
            :items="servicesTariffList"
            :fields="servicesTariffFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnDeleteServiceFromTariff(row)" class="danger fa fa-trash-alt fa-lg" v-if="row.item.links_count == 0"/>
              </template>
          </b-table>

          <modal-ok-cancel @save="saveTarrif" @cancel="$bvModal.hide('modalTariffPlans')" />
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Select parent service')" ref="modalParentServices">
      <b-table striped hover small
        :items="servicesTemplatesList"
        :fields="servicesTemplatesFields"
        selectable
        select-mode="single"
        @row-selected="rowClickedService"/>

      <modal-ok-cancel @save="showFormAddServices" @cancel="hideParentServices" />
    </b-modal>

    <FormOnceServices
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :groupList="groupList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormPeriodicServices
      id="FormPeriodicServices"
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormIPtrafficService
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormHotspotServices
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :timeRangeList="timeRangeList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormDialupServices
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :ipPoolsList="ipPoolsList"
      :timeRangeList="timeRangeList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormTelephoneService
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormIPTVService
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :schemeList="schemeList"
      :policyList="policyList"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>

    <FormVodService
      :serviceType="serviceType"
      :isTariffPlan="isTariffPlan"
      :suppliertList="suppliertList"
      :contractList="contractList"
      :editItem="selectedServices"
      :currentRowTariffPlans="currentRowTariffPlans"/>
  </div>
</template>

<script>
import FormOnceServices from '@/pages/tariffication/servicesAndTariffs/formOnceService'
import FormPeriodicServices from '@/pages/tariffication/servicesAndTariffs/formPeriodicService'
import FormIPtrafficService from '@/pages/tariffication/servicesAndTariffs/formIPtrafficService'
import FormHotspotServices from '@/pages/tariffication/servicesAndTariffs/formHotspotService'
import FormDialupServices from '@/pages/tariffication/servicesAndTariffs/formDialupService'
import FormTelephoneService from '@/pages/tariffication/servicesAndTariffs/formTelephonyService'
import FormIPTVService from '@/pages/tariffication/servicesAndTariffs/formIPTVService'
import FormVodService from '@/pages/tariffication/servicesAndTariffs/formVodService'

export default {
  components: {
    FormOnceServices,
    FormPeriodicServices,
    FormIPtrafficService,
    FormHotspotServices,
    FormDialupServices,
    FormTelephoneService,
    FormIPTVService,
    FormVodService
  },
  props: {
    timeRangeList: null,
    ipPoolsList: null,
    schemeList: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    groupList: null,
    isEdit: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      serviceType: 0,
      isTariffPlan: false,
      selectedServices: null,
      selectTemplatesService: null,
      loadingService: false,
      servicesTariffFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      servicesTemplatesFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true}
      ]
    }
  },
  methods: {
    rowClickedService (row) {
      this.selectTemplatesService = row[0]
    },
    showParentService () {
      this.selectTemplatesService = null
      this.$refs.modalParentServices.show()
    },
    hideParentServices () {
      this.$refs.modalParentServices.hide()
    },
    async showFormAddServices () {
      if (!this.selectTemplatesService) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      for (let el of this.servicesTariffList) {
        if (el.parent_id === this.selectTemplatesService.parent_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This parental service is already used in the tariff plan'), 'Error')
          return
        }
      }
      if (this.loadingService) return
      this.loadingService = true
      this.serviceType = this.selectTemplatesService.service_type
      this.selectedServices = null
      this.isTariffPlan = true
      try {
        switch (this.selectTemplatesService.service_type) {
          case 1:
            this.selectedServices = this.selectTemplatesService
            await this.$store.dispatch('Tariffing/GET_ONE_TIME_SERVICE', this.selectTemplatesService.service_id)
            this.assertServiceLoaded('ONE_TIME_SERVICE', this.selectTemplatesService.service_id)
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.cost
            this.selectedServices.drop_from_group = this.$store.getters['Tariffing/ONE_TIME_SERVICE'].once_service_data.drop_from_group
            this.selectedServices = JSON.parse(JSON.stringify(this.selectedServices))
            this.$root.$emit('bv::show::modal', 'modalOnceService', '#btnShow')
            break
          case 2:
            this.selectedServices = this.selectTemplatesService
            await this.$store.dispatch('Tariffing/GET_PERIODIC_SERVICE', this.selectTemplatesService.service_id)
            this.assertServiceLoaded('PERIODIC_SERVICE', this.selectTemplatesService.service_id)
            this.$set(this.selectedServices, 'cost', 0)
            this.selectedServices.cost = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.cost
            this.selectedServices.charge_method = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.charge_method
            this.selectedServices.policy_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.policy_id
            this.selectedServices.scheme_id = this.$store.getters['Tariffing/PERIODIC_SERVICE'].periodic_service_data.scheme_id
            this.selectedServices = JSON.parse(JSON.stringify(this.selectedServices))
            this.$root.$emit('bv::show::modal', 'modalPeriodicService', '#btnShow')
            break
          case 3:
            await Promise.all([
              this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', this.selectTemplatesService),
              this.$store.dispatch('Tariffing/GET_IP_TRAFFIC_SERVICE', this.selectTemplatesService.service_id)
            ])
            this.assertServiceLoaded('IP_TRAFFIC_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IP_TRAFFIC_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPtrafficService', '#btnShow')
            break
          case 4:
            await Promise.all([
              this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', this.selectTemplatesService),
              this.$store.dispatch('Tariffing/GET_HOTSPOT_SERVICE', this.selectTemplatesService.service_id)
            ])
            this.assertServiceLoaded('HOTSPOT_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/HOTSPOT_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalHotspotService', '#btnShow')
            break
          case 5:
            await Promise.all([
              this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', this.selectTemplatesService),
              this.$store.dispatch('Tariffing/GET_DIALUP_SERVICE', this.selectTemplatesService.service_id)
            ])
            this.assertServiceLoaded('DIALUP_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/DIALUP_SERVICE']))
            this.$set(this.selectedServices.dialup_service_data, 'pool_id', 0)
            this.selectedServices = JSON.parse(JSON.stringify(this.selectedServices))
            this.$root.$emit('bv::show::modal', 'modalDialupService', '#btnShow')
            break
          case 6:
            await Promise.all([
              this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SERVICES', this.selectTemplatesService),
              this.$store.dispatch('Tariffing/GET_TELEPHONY_SERVICE', this.selectTemplatesService.service_id)
            ])
            this.assertServiceLoaded('TELEPHONY_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TELEPHONY_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalTelephoneService', '#btnShow')
            break
          case 8:
            await this.$store.dispatch('Tariffing/GET_IPTV_SERVICE', this.selectTemplatesService.service_id)
            this.assertServiceLoaded('IPTV_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/IPTV_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalIPTVService', '#btnShow')
            break
          case 9:
            await this.$store.dispatch('Tariffing/GET_VOD_SERVICE', this.selectTemplatesService.service_id)
            this.assertServiceLoaded('VOD_SERVICE', this.selectTemplatesService.service_id)
            this.selectedServices = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/VOD_SERVICE']))
            this.$root.$emit('bv::show::modal', 'modalVodService', '#btnShow')
            break
        }
      } catch (err) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Failed to load service data'), 'Error')
      } finally {
        this.hideParentServices()
        this.loadingService = false
      }
    },
    assertServiceLoaded (storeKey, serviceId) {
      const data = this.$store.getters['Tariffing/' + storeKey]
      if (!data || !data.service_data || data.service_data.service_id !== serviceId) {
        throw new Error('Service data did not load for ' + storeKey + ' id=' + serviceId)
      }
    },
    saveTarrif () {
      if (!this.currentRowTariffPlans.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Tariff name field is invalid'), 'Error')
        return
      }

      this.currentRowTariffPlans.balance_rollover = Number(this.currentRowTariffPlans.balance_rollover)
      this.currentRowTariffPlans.tariff_id = this.currentRowTariffPlans.id
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_TARIFFS', this.currentRowTariffPlans)
        : this.$store.dispatch('Tariffing/CREATE_TARIFFS', this.currentRowTariffPlans)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
          this.$refs.modalTariffPlans.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    ClickOnDeleteServiceFromTariff (row) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of service from tariff?'), this.deleteSeriveFromTariff, row.item)
    },
    deleteSeriveFromTariff (item) {
      let tmp = {
        service_id: item.service_id,
        tariff_id: this.currentRowTariffPlans.id
      }
      let response = this.$store.dispatch('Tariffing/DELETE_SERVICE_FROM_TARIFF', tmp)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    servicesTariffList () {
      let tariffId = this.currentRowTariffPlans.id
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      for (let el of copy) {
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service link')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service link')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service link')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hotspot service link')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service link')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service link')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service link')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video service link')
            break
        }
      }
      let servicesTariffList = []
      if (tariffId) {
        servicesTariffList = copy.filter(function (value) {
          return value.tariff_id === tariffId
        })
      }
      return servicesTariffList
    },
    servicesTemplatesList () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      for (let el of copy) {
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service link')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service link')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service link')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hotspot service link')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service link')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service link')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service link')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video service link')
            break
        }
      }
      copy = copy.filter(function (value) {
        return (value.parent_id !== 0 && value.tariff_id === 0)
      })
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formTariffPlans.vue